import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_4 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = {
  class: "d-flex align-items-center",
  style: {"width":"200px"}
}
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_17 = { class: "dropdown-menu dropdown-block" }
const _hoisted_18 = {
  key: 0,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_19 = {
  key: 1,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 2,
  class: "dropdown-item d-flex align-items-center"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  class: "modal fade",
  id: "create-task",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_24 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_25 = { class: "modal-content" }
const _hoisted_26 = { class: "modal-body px-4" }
const _hoisted_27 = { class: "row gy-2" }
const _hoisted_28 = { class: "col-md-4-3" }
const _hoisted_29 = { class: "modal-footer" }
const _hoisted_30 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Liste des créances")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.checkPermission('AddCreance'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              class: "btn btn-primary",
              to: "/creances/ajouter-creance"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                _createTextVNode(" Ajouter une créance ")
              ])),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.point_ventes.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Filtrer par Point de vente ", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.point_vente,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.point_vente) = $event)),
                  options: _ctx.point_ventes,
                  searchable: true,
                  "track-by": "label",
                  label: "label",
                  placeholder: "Sélectionner un point de vente"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("form", {
          class: "search-bg svg-color pt-3",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black",
            placeholder: "Rechercher une creance"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("button", {
            type: "submit",
            class: "bg-transparent text-primary transition p-0 border-0"
          }, [
            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
          ], -1))
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date Créance "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Client "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Nbre Echeance "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Montant total "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Statut "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              }, " Actions ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creances, (creance, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.format_Date(creance.date)), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(creance?.client.nomClient && creance?.client.prenomClient ? `${creance?.client.nomClient} ${creance?.client.prenomClient}` : creance?.client.raisonSociale), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(creance.nbreEcheance), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.separateur(creance.montant)), 1),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['badge', _ctx.getStatutBadge(creance.statut).class])
                  }, _toDisplayString(_ctx.getStatutBadge(creance.statut).text), 3)
                ]),
                _createElementVNode("td", _hoisted_16, [
                  _cache[11] || (_cache[11] = _createElementVNode("button", {
                    class: "btn dropdown-toggle btn-primary",
                    type: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, " Actions ", -1)),
                  _createElementVNode("ul", _hoisted_17, [
                    (_ctx.checkPermission('ViewCreance'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                          _createVNode(_component_router_link, {
                            to: { name: 'ViewCreance', params: { id: creance.id } },
                            class: "dropdown-item d-flex align-items-center"
                          }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode("Détails ")
                            ])),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : _createCommentVNode("", true),
                    (creance.statut === -1 && _ctx.checkPermission('ValidateCreance'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#create-task",
                            onClick: ($event: any) => (_ctx.openModal(creance.id))
                          }, _cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "fa fa-check-circle lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode("Traiter ")
                          ]), 8, _hoisted_20)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.checkPermission('DeleteCreance'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.suppression(creance.id, _ctx.creances, 'creances', `la créance ${creance.id}`))
                          }, _cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode("Supprimer ")
                          ]), 8, _hoisted_22)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "modal-header" }, [
              _createElementVNode("h6", { class: "modal-title" }, "Voulez-vous traiter cette créance ?"),
              _createElementVNode("button", {
                type: "button",
                id: "close-modal",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_Form, {
                ref: "creancesForm",
                onSubmit: _ctx.addCreances,
                "validation-schema": _ctx.creancesSchema
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block fw-semibold mb-10" }, [
                        _createTextVNode(" Observation"),
                        _createElementVNode("span", { class: "text-danger" })
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "observation",
                        as: "textarea",
                        placeholder: "Entrer l'observation",
                        class: "form-control shadow-none rounded-0 text-black"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "observation",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _cache[14] || (_cache[14] = _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-primary"
                    }, "Accepter", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rejectCreances && _ctx.rejectCreances(...args))),
                      "aria-label": "Close"
                    }, " Rejeter ")
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}